export default "__VITE_ASSET__DHDP8wIq__"